import { render } from "./CheckItem.vue?vue&type=template&id=6853aa7c&scoped=true"
import script from "./CheckItem.vue?vue&type=script&lang=js"
export * from "./CheckItem.vue?vue&type=script&lang=js"

import "./CheckItem.vue?vue&type=style&index=0&id=6853aa7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6853aa7c"]])

export default __exports__